import { useQuery } from "@tanstack/react-query";
import { fetchIntradayChartData } from "~api/chart-data/fetchIntradayChartData";
import { SECTION_FRONT_REFRESH_INTERVAL_IN_MS } from "~constants";

export const useTodayInMarketsSparklineData = (tickers: string[]) => {
  const sparklineCacheKey = tickers.sort().join(",");

  return useQuery({
    queryKey: ["tim-sparkline-bulk", sparklineCacheKey],
    queryFn: () => fetchIntradayChartData(tickers),
    enabled: tickers.length > 0,
    staleTime: SECTION_FRONT_REFRESH_INTERVAL_IN_MS,
    refetchInterval: SECTION_FRONT_REFRESH_INTERVAL_IN_MS,
  });
};
